import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MusicNotesIcon from "../../assets/icons/musicNotesIcon";
import Button from "../../components/button";
import PopUp, { closePopUp } from "../../components/popUp";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useAppContext } from "../../context/appContext";

interface AddAccountCreditSuccessPopUpProps {
    refetch: () => Promise<any>;
}

export default function AddAccountCreditSuccessPopUp(props: AddAccountCreditSuccessPopUpProps) {
    
    const {purchaseController, isLoggedIn, sessionId} = useAppContext();

    const [error, setError] = useState("");

    useEffect(() => {
        if(!isLoggedIn) {
            setError("You are not logged in.");
            return;
        }
        purchaseController.checkCreditPurchaseCheckout(sessionId).catch((e) => {
            setError("An error occurred while verifying your purchase. Please contact support if the issue persists.");
        }).then((response) => {
                props.refetch();
        });
    })

    const navigate = useSafeNavigate(useNavigate());


    return <PopUp onClose={() => {
        navigate("/dashboard/overview");
    }} className="big buy-success" title="">
        {error ? <>
            <h1>An error occurred</h1>
            <h2>{error}</h2>
            <Button onClick={() => {
                closePopUp();
                navigate("/dashboard/overview");
            }}>Close</Button>
        </> : <>
            <h1>Thank You!</h1>
            <h3>The credit was successfully added to your account.</h3>
            <p>You can now use the money to go out and buy pieces.</p>
            <Button onClick={() => {
                closePopUp();
                navigate("/dashboard/overview");
            }}>Awesome!<MusicNotesIcon/></Button>
        </>}
    </PopUp>;

}